import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from '../../../../../ui';
import styles from './assessment_complete.module.css';

export const AssessmentComplete = () => {
  const history = useHistory();

  const stopAllMediaStreams = () => {
    // Get all video and audio elements
    const videos = document.querySelectorAll('video');
    const audios = document.querySelectorAll('audio');

    // Stop all video streams
    videos.forEach((video) => {
      if (video.srcObject) {
        const stream = video.srcObject as MediaStream;
        stream.getTracks().forEach((track) => {
          track.stop();
        });
        video.srcObject = null;
      }
    });

    // Stop all audio streams
    audios.forEach((audio) => {
      if (audio.srcObject) {
        const stream = audio.srcObject as MediaStream;
        stream.getTracks().forEach((track) => {
          track.stop();
        });
        audio.srcObject = null;
      }
    });

  };

  // Stop all media streams when component mounts
  useEffect(() => {
    stopAllMediaStreams();

    // Cleanup on unmount
    return () => {
      stopAllMediaStreams();
    };
  }, []);

  const logOut = () => {
    // Clean up all media streams before logging out
    stopAllMediaStreams();
    localStorage.clear();
    history.push('/login');
  };

  return (
    <div className={styles.assessmentCompleteContainer}>
      <div className={styles.messageContainer}>
        { /* Modern, Minimal Celebration UI */ }
        <div className='flex flex-col items-center justify-center space-y-6 max-w-2xl mx-auto'>
          { /* Success Icon */ }
          <div className='relative'>
            <div className='w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center shadow-lg animate-bounce'>
              <svg
                  className='w-12 h-12 text-white'
                  fill='none'
                  viewBox='0 0 24 24'
                  stroke='currentColor'
              >
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={3}
                    d='M5 13l4 4L19 7'
                />
              </svg>
            </div>
            <div className='absolute -top-2 -right-2 text-4xl animate-pulse'>
              🎉
            </div>
          </div>

          { /* Congratulations Text */ }
          <div className='text-center space-y-3'>
            <h1 className='text-4xl md:text-5xl font-bold text-gray-900 tracking-tight'>
              Congratulations{ localStorage.getItem('firstname') && ',' }{ ' ' }
              <span className='bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent'>
                { localStorage.getItem('firstname') || 'Candidate' }
              </span>
              !
            </h1>
            <p className='text-lg md:text-xl text-gray-600 font-medium'>
              You have successfully completed the assessment.
            </p>
          </div>

          { /* Success Message */ }
          <div className='bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6 border border-blue-100'>
            <p className='text-center text-gray-700 text-base'>
              Your responses have been recorded and submitted successfully.
              <br />
              <span className='text-sm text-gray-500 mt-2 inline-block'>
                Thank you for your time and effort.
              </span>
            </p>
          </div>

          { /* Action Button */ }
          <div className='pt-4'>
            <Button
                variant='secondary'
                label='Log Out'
                onClick={() => logOut()}
                className='px-8 py-3 text-base font-semibold'
            />
          </div>
        </div>
      </div>
    </div>
  );
};
